/* FIXTERIOR theme — global interactions */
(function () {
  'use strict';
  var FIXT = window.FIXT || {};

  function ready(fn) { if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); } }
  function money(cents) {
    var fmt = FIXT.money_format || '£{{amount}}';
    return fmt.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, (cents / 100).toFixed(2));
  }

  // ---------- Cart drawer ----------
  function drawer() { return document.querySelector('[data-cart-drawer]'); }
  function overlay() { return document.querySelector('[data-drawer-overlay]'); }

  function openCart() {
    var d = drawer(), o = overlay();
    if (!d) return;
    if (o) o.hidden = false;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
  }
  function closeDrawers() {
    var d = drawer(), o = overlay();
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (o) o.hidden = true;
    document.body.classList.remove('drawer-open');
    closeSearch();
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (e) { e.textContent = cart.item_count; });
    var body = document.querySelector('[data-cart-items]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
      var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<div class="ci-variant">' + it.variant_title + '</div>' : '';
      return '<div class="cart-item" data-key="' + it.key + '">'
        + '<a href="' + it.url + '" class="ci-img">' + img + '</a>'
        + '<div class="ci-main"><div class="ci-name">' + it.product_title + '</div>' + variant
        + '<div class="ci-qty"><button type="button" data-cd="-1" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button type="button" data-cd="1" aria-label="Increase">+</button>'
        + '<button type="button" class="ci-remove" data-cd="0">Remove</button></div></div>'
        + '<div class="ci-price">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    if (foot) { foot.hidden = false; var sub = document.querySelector('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.total_price); }
    body.querySelectorAll('.cart-item').forEach(function (row) {
      var key = row.getAttribute('data-key');
      row.querySelectorAll('[data-cd]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = Number(btn.getAttribute('data-cd'));
          var cur = Number(row.querySelector('.ci-qty span').textContent) || 1;
          changeLine(key, delta === 0 ? 0 : Math.max(0, cur + delta));
        });
      });
    });
  }

  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function refreshCart() { return fetchCart().then(renderCart).catch(function () {}); }
  function changeLine(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  window.fixtAddToCart = function (id, qty) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openCart(); });
  };
  window.fixtOpenCart = openCart;

  // ---------- Predictive search ----------
  function searchOverlay() { return document.querySelector('[data-search-overlay]'); }
  function openSearch() {
    var s = searchOverlay(); if (!s) return;
    s.setAttribute('aria-hidden', 'false'); s.classList.add('open');
    document.body.classList.add('drawer-open');
    var i = s.querySelector('[data-search-input]'); if (i) setTimeout(function () { i.focus(); }, 50);
  }
  function closeSearch() {
    var s = searchOverlay(); if (!s) return;
    s.setAttribute('aria-hidden', 'true'); s.classList.remove('open');
  }
  var searchTimer;
  function doSearch(q) {
    var box = document.querySelector('[data-search-results]'); if (!box) return;
    if (!q || q.length < 2) { box.innerHTML = ''; return; }
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var items = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!items.length) { box.innerHTML = '<p class="search-empty">No matches — press Enter to search everything.</p>'; return; }
        box.innerHTML = items.map(function (p) {
          var img = p.image ? '<img src="' + p.image + '" alt="">' : '<span class="sr-noimg"></span>';
          return '<a class="search-result" href="' + p.url + '">' + img + '<span class="sr-title">' + p.title + '</span></a>';
        }).join('');
      }).catch(function () {});
  }

  ready(function () {
    // mobile menu
    var mt = document.querySelector('[data-menu-toggle]'), mm = document.querySelector('[data-mobile-menu]'), hdr = document.querySelector('header');
    if (mt && mm) { mt.addEventListener('click', function () { var o = mm.classList.toggle('is-open'); if (o && hdr) { mm.style.top = hdr.getBoundingClientRect().bottom + 'px'; } mt.setAttribute('aria-expanded', o ? 'true' : 'false'); document.body.classList.toggle('menu-open', o); }); }

    // tabs
    document.querySelectorAll('[data-tabs]').forEach(function (g) {
      g.querySelectorAll('[data-tab]').forEach(function (t) {
        t.addEventListener('click', function () { g.querySelectorAll('[data-tab]').forEach(function (x) { x.classList.remove('active'); }); t.classList.add('active'); });
      });
    });

    // quick add on product cards
    document.querySelectorAll('[data-add-variant]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = btn.getAttribute('data-add-variant'); if (!id) return;
        btn.disabled = true; var o = btn.innerHTML;
        window.fixtAddToCart(id, 1).then(function () { btn.innerHTML = '&#10003;'; setTimeout(function () { btn.innerHTML = o; btn.disabled = false; }, 1000); })
          .catch(function () { btn.innerHTML = o; btn.disabled = false; });
      });
    });

    // open/close cart
    document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(openCart); }); });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawers); });
    var ov = overlay(); if (ov) ov.addEventListener('click', closeDrawers);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

    // search
    document.querySelectorAll('[data-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); });
    document.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
    var si = document.querySelector('[data-search-input]');
    if (si) si.addEventListener('input', function () { clearTimeout(searchTimer); var q = si.value; searchTimer = setTimeout(function () { doSearch(q); }, 250); });

    // initialise cart count/contents
    refreshCart();

    // scroll reveal
    var rev = document.querySelectorAll('.reveal');
    if (rev.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }); }, { threshold: 0.12 });
      rev.forEach(function (x) { io.observe(x); });
    } else { rev.forEach(function (x) { x.classList.add('in'); }); }

    // hero product showcase — auto-rotating, clickable, with dots
    document.querySelectorAll('[data-hero-carousel]').forEach(function (c) {
      var slides = c.querySelectorAll('.hero-slide');
      if (slides.length < 2) return;
      var dotsWrap = c.querySelector('[data-hero-dots]');
      var dots = [];
      slides.forEach(function (s, idx) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Show product ' + (idx + 1));
        if (idx === 0) b.classList.add('active');
        b.addEventListener('click', function () { go(idx); });
        if (dotsWrap) dotsWrap.appendChild(b);
        dots.push(b);
      });
      var i = 0, timer;
      function go(n) {
        slides[i].classList.remove('active'); if (dots[i]) dots[i].classList.remove('active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('active'); if (dots[i]) dots[i].classList.add('active');
        start();
      }
      function start() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 3800); }
      start();
    });
  });
})();
